import { render } from "./RegisterComp.vue?vue&type=template&id=2b5e3cee&scoped=true"
import script from "./RegisterComp.vue?vue&type=script&lang=js"
export * from "./RegisterComp.vue?vue&type=script&lang=js"

import "./RegisterComp.vue?vue&type=style&index=0&id=2b5e3cee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5e3cee"]])

export default __exports__